export default "<button title=\"Upload\" \r\nclass=\"btn btn-success\" \r\n[disabled]=\"disable\"\r\n(click)=\"Upload()\">Upload</button>";